    <app-auth2-header></app-auth2-header>

    <router-outlet></router-outlet>
    <app-auth2-footer></app-auth2-footer>

